export default __webpack_public_path__ + "static/media/paymentFailed.ecf06809.svg";